export default __webpack_public_path__ + "static/media/Pastry.528811a8.png";